// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GiftCardsSection_wrapper__gR0CH","title":"GiftCardsSection_title__R3M0c"};